// Estratto da DocumentoUploadField/BollettaUploadField (nessun cambio di comportamento):
// input dinamico mai montato nel DOM, aperto con .click(). Su telefono `capture`
// apre la fotocamera; `showOpenFilePicker` non è disponibile lì.
export function pick(accept: string, capture: "environment" | undefined, onPicked: (files: File[]) => void) {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = accept;
  input.multiple = true;
  if (capture) input.setAttribute("capture", capture);
  input.onchange = () => {
    const picked = Array.from(input.files ?? []);
    if (picked.length) onPicked(picked);
  };
  input.click();
}
